import apiClient from './apiClient';
import { API_ENDPOINTS } from '../config/api';
import { DbBreakglassRequestResponse, CreateDbBreakglassRequest } from '../types/dbBreakglass';

export const dbBreakglassService = {
  createRequest: async (request: CreateDbBreakglassRequest): Promise<DbBreakglassRequestResponse> =>
    apiClient.post<DbBreakglassRequestResponse>(API_ENDPOINTS.dbBreakglassRequests, request),
};
